import {
    RuleDescriptor,
    RuleExpression
} from '../site-config/trackableConfig';

RuleDescriptor.prototype._ModelExtender = function (model, p, pp, mappingOptions) {
    mappingOptions.expression = {
        create: function (options) {
            return new RuleExpression(options.data);
        }
    }
}

export default {};